import { keepPreviousData, useQuery } from '@tanstack/react-query'

import { executionsApi } from '@/lib/api'
import { queryKeys } from '@/lib/queryClient'
import type { ExecutionFilters } from '@/types/domain'

export const DEFAULT_EXECUTION_FILTERS: ExecutionFilters = { limit: 50, offset: 0 }

export function useExecutions(filters: ExecutionFilters) {
  return useQuery({
    queryKey: queryKeys.executions(filters),
    queryFn: () => executionsApi.list(filters),
    // Keeps the previous page on screen while the next one loads, so paging does not
    // flash an empty table and shift the layout.
    placeholderData: keepPreviousData,
  })
}

export function useExecutionDetail(requestId: string | null) {
  return useQuery({
    queryKey: queryKeys.execution(requestId ?? ''),
    queryFn: () => executionsApi.detail(requestId as string),
    enabled: Boolean(requestId),
  })
}
